import { Dictionary } from "src/types/language";

import { base } from "./base";
import { events } from "./events";
import { modals } from "./modals";
import { pages } from "./pages";
import { telegram } from "./telegram";
import { terms } from "./terms";
import { widgets } from "./widgets";

/**
 * Английский словарь. Тип `Dictionary` (= ключи русского словаря) заставляет
 * TypeScript ругаться на любой пропущенный или лишний ключ — это и есть
 * проверка полноты перевода на этапе сборки.
 */
export const en: Dictionary = {
  ...base,
  ...events,
  ...pages,
  ...telegram,
  ...terms,
  ...modals,
  ...widgets,
};
